import { render, staticRenderFns } from "./add-provider.component.vue?vue&type=template&id=35e6fc6d&"
import script from "./add-provider.component.vue?vue&type=script&lang=ts&"
export * from "./add-provider.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports